module.exports = __webpack_public_path__ + "img/active.18632160.png";